import React from "react";
import { Check } from "lucide-react";

const chip = (on) =>
  `rounded-xl border px-3.5 py-2.5 text-sm text-left transition-[background-color,border-color,transform] duration-150 active:scale-[0.98] ${
    on ? "border-[#165a71] bg-[#165a71] text-white" : "border-slate-200 bg-white hover:border-[#165a71]/50 text-[#071b22]"
  }`;

export const QuestionField = ({ q, value, onChange }) => {
  const tid = `q-${q.id}`;
  const label = (
    <div className="mb-2">
      <div className="text-sm font-semibold text-[#071b22]">
        {q.label} {q.required && <span className="text-[#d97757]">*</span>}
      </div>
      {q.help && <div className="text-xs text-[#252A34]/60 mt-0.5">{q.help}</div>}
    </div>
  );
  if (q.type === "single" || q.type === "yesno") {
    return (
      <div data-testid={tid}>
        {label}
        <div className="flex flex-wrap gap-2">
          {q.options.map((o) => (
            <button type="button" key={o} onClick={() => onChange(value === o ? null : o)} className={chip(value === o)} data-testid={`${tid}-opt-${o}`}>{o}</button>
          ))}
        </div>
      </div>
    );
  }
  if (q.type === "multi") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (o) => onChange(arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o]);
    return (
      <div data-testid={tid}>
        {label}
        <div className="flex flex-wrap gap-2">
          {q.options.map((o) => (
            <button type="button" key={o} onClick={() => toggle(o)} className={`${chip(arr.includes(o))} inline-flex items-center gap-1.5`} data-testid={`${tid}-opt-${o}`}>
              {arr.includes(o) && <Check className="h-3.5 w-3.5" />}{o}
            </button>
          ))}
        </div>
      </div>
    );
  }
  return (
    <label className="block" data-testid={tid}>
      {label}
      {q.type === "textarea" ? (
        <textarea rows={4} value={value || ""} onChange={(e) => onChange(e.target.value)} className="sr-input" data-testid={`${tid}-input`} />
      ) : (
        <input type={q.type === "number" ? "number" : "text"} value={value ?? ""} onChange={(e) => onChange(q.type === "number" ? (e.target.value === "" ? null : Number(e.target.value)) : e.target.value)} className="sr-input max-w-md" data-testid={`${tid}-input`} />
      )}
    </label>
  );
};

export const isVisible = (q, answers) => {
  if (!q.show_if) return true;
  const v = answers[q.show_if.q];
  const vals = Array.isArray(v) ? v : [v];
  return vals.some((x) => (q.show_if.in || []).includes(x));
};

export const SR_STYLES = `
  .sr-input { width: 100%; border-radius: 0.85rem; border: 1px solid #e2e8f0; background: white; padding: 0.7rem 0.85rem; font-size: 0.9rem; outline: none; transition: border-color .15s, box-shadow .15s; }
  .sr-input:focus { border-color: #165a71; box-shadow: 0 0 0 4px rgba(22, 90, 113, 0.12); }
  @keyframes srIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
  .sr-in { animation: srIn .35s ease both; }
`;
